// RolesList.js
import React from 'react';
import PropTypes from 'prop-types';
import { generateClassName } from '../../../b2b-common/helpers';

import './RolesList.css';


const RolesList = ({ roles, className }) => {
    return (
        <ul className={generateClassName("b2b-roles", "-list", className)}>
            {roles.map(role => (
                <li key={role.roleId} className={generateClassName("b2b-roles", "-list-item", className)}>
                    {role.roleName}
                </li>
            ))}
        </ul>
    );
};

RolesList.propTypes = {
    roles: PropTypes.arrayOf(
        PropTypes.shape({
            roleId: PropTypes.number.isRequired,
            roleName: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export default RolesList;
